module.exports = __webpack_public_path__ + "img/deliveryMain.98e7623d.jpeg";